<!-- eslint-disable no-unused-vars -->
<!-- eslint-disable no-unused-vars -->
<template>
  <div id="own-vessel-card" @click="jumpTo" :class="{disabled: isDisabledBtn}">
    <vx-card v-if="ownVessel">
      <div class="vessel-card-content">
        <div class="vessel-image-area">
          <div class="avatar-container">
            <div class="picture-text" v-show="!hasPicture">{{ pictureText }}</div>
            <vs-avatar class="avatar" :src="picture" size="53px" />
            <img v-show="countryFlag" :src="countryFlag" class="country-flag" border="1" />
          </div>
        </div>
        <div class="vessel-info-area">
          <div class="vessel-name-wrap">
          <div class="aisea-text-14-700-white truncate vessel-name">
            {{ ownVesselName }}
          </div>
          </div>
          <div class="vessel-state">
            <div class="state-lamp-circle" :style="{'--color': statusLampColor}" :class="{'blink': isStatusLampBlink}">
              <div class="state-lamp-outer"></div>
              <div class="state-lamp-inner"></div>
            </div>
            <span class="state-label aisea-text-12-400-white">
              {{vesselOperations}}
            </span>
          </div>
          <div
            class="aisea-text-12-400-white destination"
            >{{ $t("Views.Vessel.Destination") }}:
            {{ destination }}</div
          >
          <div
            class="aisea-text-12-400-white eta"
            >{{ $t("Views.Vessel.ETA") }}:
            {{ eta }}</div
          >
          <span
            class="aisea-text-12-400-white velocity"
            >{{ $t("Views.Vessel.Velocity") }}:
            {{ speed }}kn</span
          >
          <span
            class="aisea-text-12-400-white heading"
            >{{ $t("Views.Vessel.Heading") }}:
            {{ heading }}°</span
          >
        </div>
        <div class="button-area">
          <div
            class="aisea-text-12-400-white last-received"
            >
            <feather-icon
              class="clock-icon"
              icon="ClockIcon"
              svgClasses="w-4 h-4"
            ></feather-icon>
            <div>
            {{
              lastReceived
            }}
            </div>
            </div
          >
          <vs-button
            class="wake-line-button vs-con-loading__container"
            :class="{'active': hasWakes(ownVessel.id), 'inactive': !hasWakes(ownVessel.id)}"
            size="small"
            :color="hasWakes(ownVessel.id) ? btnStyle.activeColor : btnStyle.inactiveColor"
            :disabled="isDisabledBtn"
            type="filled"
            icon-pack="feather"
            icon="icon-flag"
            @click.stop="onFetchWake"
            ref="wakeLineButton"
          >航跡</vs-button>
          <vs-button
            class="detail-button"
            :class="{'active': isShowingDetail(ownVessel.id), 'inactive': !isShowingDetail(ownVessel.id)}"
            size="small"
            :color="isShowingDetail(ownVessel.id) ? btnStyle.activeColor : btnStyle.inactiveColor"
            type="filled"
            icon-pack="feather"
            icon="icon-info"
            @click.stop="switchShowDetail(isShowingDetail(ownVessel.id))"
          >詳細</vs-button>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import { DateUtil } from "@/utils";
import { storage } from "@/firebase/firebaseConfig";
import { db } from "@/firebase/firebaseConfig.js";
import AuthService from "@/services/authService.js";
import moment from "moment-timezone";
import Mapbox from "mapbox-gl";
import { createNamespacedHelpers, mapState } from "vuex";
import * as Enum from "@/config/const.js";
import { getStatusLamp } from "@/utils/VesselUtil";

// Store
const {
  mapGetters: mapGettersOfLiveMap,
  mapActions: mapActionsOfLiveMap
} = createNamespacedHelpers("liveMap");

export default {
  props: {
    ownVessel: { type: Object, default: null }
  },
  data() {
    return {
      vesselInfo: null,
      vesselPosition: null,
      aisInfo: null,
      picture: require("@/assets/images/no_image_bg.svg"),
      hasPicture: false,
      isSelectedMail: this.isSelected,
      unsubscribes: [],
      btnStyle: {
        activeColor: "#649ACF",
        inactiveColor: "#ffffff",
      },
      defaultValues: {
        num: "0",
        chara: "---",
        text: ""
      },

      isWakeLineLoading: false
    };
  },
  watch: {
    ownVessel: {
      immediate: true,
      handler: function() {
        this.crateVesselInfo();
        this.setPicture();
        this.subscribeAisInfo();
      }
    },
    vesselPosition(newPosition) {
      let payload = {
        vesselId: this.ownVessel.id,
        position: newPosition,
        ais: this.aisInfo
      };
      this.$emit("onChangePosition", payload);
    }
  },
  computed: {
    ...mapGettersOfLiveMap(["getCountryAlpha2", "hasWakes", "getVesselDetail", "showVesselDetail"]),
    ...mapState({
      NAVIGATION_STATUS: () => Enum.NAVIGATION_STATUS
    }),
    isDisabledBtn() {
      return this.vesselPosition === null;
    },
    labelColor() {
      return label => {
        const tags = this.tags;
        return tags.find(tag => {
          return tag.value == label;
        }).color;
      };
    },
    destination() {
      if (this.aisInfo) {
        return this.aisInfo.dt !== undefined
          ? this.aisInfo.dt
          : this.defaultValues.chara;
      } else {
        return this.defaultValues.chara;
      }
    },
    eta() {
      if (this.aisInfo) {
        return this.aisInfo.eta && Object.prototype.hasOwnProperty.call(this.aisInfo.eta, 'seconds')
          ? moment(this.aisInfo.eta.seconds * 1000).format("YYYY/MM/DD HH:mm")
          : this.defaultValues.chara;
      } else {
        return this.defaultValues.chara;
      }
    },
    speed() {
      if (this.vesselPosition) {
        return this.vesselPosition.v !== undefined
          ? this.vesselPosition.v
          : this.defaultValues.num;
      } else {
        return this.defaultValues.num;
      }
    },
    heading() {
      if (this.vesselPosition) {
        return this.vesselPosition.h !== undefined ||
          this.vesselPosition.h !== 0
          ? this.vesselPosition.h
          : this.vesselPosition.d !== undefined
          ? this.vesselPosition.d
          : this.defaultValues.num;
      } else {
        return this.defaultValues.num;
      }
    },
    lastReceived() {
      if (this.vesselPosition) {
        return this.vesselPosition.t !== undefined
          ? DateUtil.elapsedTimeByTimestamp(this.vesselPosition.t)
          : this.defaultValues.chara;
      } else {
        return this.defaultValues.chara;
      }
    },
    ownVesselName() {
      if (this.ownVessel) {
        if(this.ownVessel.name_ja !== null) {
          return this.ownVessel.name_ja
        } else if(this.ownVessel.name !== null) {
          return this.ownVessel.name
        } else {
          return `${this.ownVessel.mmsi}(MMSI)`
        }
      } else {
        return "";
      }
    },
    pictureText() {
      if (this.ownVessel) {
        return this.ownVessel.name !== null
          ? this.ownVessel.name.charAt(0)
          : "";
      } else {
        return "";
      }
    },
    countryFlag() {
      if (!this.ownVessel) return;
      let countryAlpha2 = this.getCountryAlpha2(this.ownVessel.country_code.id);
      return countryAlpha2 ? require(`@/assets/images/flags/${countryAlpha2}.svg`) : null;
    },
    vesselOperations() {
      const pos = this.vesselPosition
      if (pos == null || pos.s == null) {
        return "-";
      }
      return this.NAVIGATION_STATUS.properties[String(pos.s)].name_ja;
    },
    statusLampColor() {
      const pos = this.vesselPosition
      if (pos == null || pos.s == null) {
        return getStatusLamp(null).color;
      }
      return getStatusLamp(pos.s).color
    },
    isStatusLampBlink() {
      return false
      /* TODO: 点滅表現が必要になったらコメントアウト外す
      const pos = this.vesselPosition
      if (pos == null || pos.s == null) {
        return false;
      }
      return getStatusLamp(pos.s).blink
      */
    },
  },
  methods: {
    ...mapActionsOfLiveMap(["cleanUpVesselDetail"]),
    isShowingDetail(vesselId) {
      return this.getVesselDetail ? this.getVesselDetail.id == vesselId && this.showVesselDetail : false
    },
    switchShowDetail(isShowing){
      if (isShowing) {
        this.cleanUpVesselDetail()
      } else {
        this.$emit("showDetails", this.ownVessel.id);
      }
    },
    showDetails() {
      this.$emit("showDetails", this.ownVessel.id);
    },

    async jumpTo() {
      if (this.isDisabledBtn) return

      let res = await this.$store.dispatch(
        "enterpriseVoyageHistory/getLastPosition",
        this.ownVessel.id
      );
      if (res.data) {
        let lastPosition = res.data;

        if (lastPosition) {
          let coordinates = {
            center: [lastPosition.longitude, lastPosition.latitude],
          };
          this.$emit("jumpToMap", coordinates);
        }
      }
      this.showNotifyTimeout(res.data);
    },

    crateVesselInfo() {
      this.vesselInfo = {
        id: this.ownVessel.id,
        name: this.ownVessel.name_ja || this.ownVessel.name,
        category: Number(this.ownVessel.vessel_category.id)
      };
    },

    setPicture() {
      if (this.ownVessel.pictures.length !== 0) {
        storage
          .child(this.ownVessel.pictures[0].thumbnail_path)
          .getDownloadURL()
          .then(response => {
            this.hasPicture = true;
            this.picture = response;
          });
      } else {
        this.hasPicture = false;
      }
    },

    async subscribeVesselPosition() {
      const collectionName = await AuthService.getVesselPositionCollectionName();
      let unsubscribe = await db
        .collection(collectionName)
        .doc(this.ownVessel.id)
        .onSnapshot(
          doc => {
            if (doc.data() !== undefined) {
              this.vesselPosition = doc.data();
            }
          },
          function(_) {}
        );
      this.unsubscribes.push(unsubscribe);
    },

    async subscribeAisInfo() {
      let unsubscribe = await db
        .collection("vessel_info")
        .doc(this.ownVessel.id)
        .onSnapshot(
          doc => {
            if (doc.data() !== undefined) {
              this.aisInfo = doc.data();
              this.subscribeVesselPosition();
            }
          },
          function(_) {}
        );
      this.unsubscribes.push(unsubscribe);
    },

    onFetchWake() {
      if (!this.isWakeLineLoading) {
        this.$emit("onFetchWake", {
          vesselId: this.ownVessel.id,
          name: this.ownVessel.name_ja || this.ownVessel.name,
          cardComponent: this
        });
      }
    },

    elapsedTime(startTime) {
      return DateUtil.elapsedTime(startTime);
    },

    showNotifyTimeout(lastPosition) {
      if (lastPosition && lastPosition.latitude && lastPosition.longitude) {
        const tenMinutesAgo = moment()
          .subtract(10, "minutes")
          .utc()
          .unix();
        const lastPosAt = moment(lastPosition.last_position_at).unix();

        // 最終計測時間が10分前の場合
        if (lastPosAt < tenMinutesAgo) {
          const name = lastPosition.vessel_name_ja || lastPosition.vessel_name;
          const dateFormat =
            moment(lastPosition.last_position_at).format("YYYY/MM/DD HH:mm");
          let elapsed = DateUtil.elapsedTime(dateFormat);
          let expiredPopup = new Mapbox.Popup({
            closeOnClick: false,
            closeButton: true,
            offset: 15
            })
            .setLngLat([lastPosition.longitude, lastPosition.latitude])
            .setText(
              `${name}はこの位置で、${elapsed}(${dateFormat})に記録されました。`
            )
          this.$emit("createExpiredPopup", expiredPopup);
        }
      } else {
        this.$vs.notify({
          text: "位置情報が取得できません。",
          color: "danger",
          iconPack: "feather",
          icon: "icon-alert-circle",
          position: "top-center"
        });
      }
    }
  },
  beforeDestroy() {
    if (this.unsubscribes.length !== 0) {
      this.unsubscribes.forEach(unsubscribe => unsubscribe());
      this.unsubscribes = [];
    }
  }
};
</script>

<style lang="scss">
@import "src/assets/scss/aisea/variables";

#own-vessel-card {
  margin-left: auto;
  cursor: pointer;
  &.disabled {
    cursor: default !important;
    .con-vs-avatar {
      cursor: default !important;
    }
  }
  .vx-card{
    background: $aisea-blue-gray;
    .vx-card__body {
      padding: 0.9rem;
    }
  }
  .vessel-card-content {
    display: flex;
    .vessel-image-area {
      min-width: 70px;
      .avatar-container {
        position: relative;
        width: fit-content;
        height: fit-content;
        display: flex;
        justify-content: center;
        align-items: center;
        .picture-text {
          position: absolute;
          color: $aisea-pure-white;
          z-index: 1;
          font-size: 23px;
        }
        .country-flag {
          position: absolute;
          width: 24px !important;
          right: 8px;
          bottom: -3px;
        }
      }
    }
    .vessel-info-area {
      flex: auto;
      .vessel-name-wrap {
        display: table;
        table-layout: fixed;
        width: 100%;
        .vessel-name {
          font-size: 16px;
          line-height: 1;
          margin-bottom: 3px;
        }
      }
      
      .vessel-state {
        display: flex;
        align-items: center;
        font-size: 14px;
        margin-bottom: 3px;
        .state-lamp-circle {
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
          width: 15px;
          height: 15px;
          &.blink {
            animation: blinkAnime 1s infinite alternate;
          }
          @keyframes blinkAnime{
            0% { opacity: 0 }
          100% { opacity: 1 }
          }
          .state-lamp-outer {
            width: 15px;
            height: 15px;
            opacity: 0.5;
            background: var(--color);
            border-radius: 10px;
            position: absolute;
          }
          .state-lamp-inner {
            width: 9px;
            height: 9px;
            background: var(--color);
            border-radius: 10px;
            position: absolute;
          }
        }
        .state-label {
          margin-left: 7px;
        }
      }
      .destination {
        margin-bottom: 2px;
      }
      .eta {
        line-height: 1;
      }
      .velocity {
        line-height: 1;
        width: 73px;
        display: inline-block;
      }
      .heading {
        line-height: 1;
        display: inline-block;
      }
    }
    .button-area {
      min-width: 88px;
      .last-received {
        display: flex;
        margin-bottom: 6px;
        .clock-icon {
          margin-left: 6px;
          margin-right: 6px;
        }
      }
      .wake-line-button, .detail-button {
        margin-bottom: 7px;
        &.active {
          color: $aisea-pure-white !important
        }
        &.inactive {
          color: $aisea-blue !important
        }
      }
    }
  }
}
</style>
